/**
 * TanStack Router: /performance/radar/:employeeId/tree
 *
 * Hierarchical tree view starting from an employee.
 * Displays org chart with performance indicators.
 *
 * @see packages/web-apps/monutrack/docs/PERFORMANCE-RADAR-frontend-spec.md
 */
import { createFileRoute } from '@tanstack/react-router'
import { RadarTreePage } from '@/components/performance/radar/RadarTreePage'
import { z } from 'zod'

/**
 * Search params schema for tree view
 */
const searchSchema = z.object({
  depth: z.coerce.number().min(1).max(15).optional().default(3),
})

/**
 * Route: /performance/radar/:employeeId/tree
 * Layout: _auth/performance/radar
 * Component: RadarTreePage
 *
 * Query Params:
 * - depth: number (1-15, default: 3)
 */
export const Route = createFileRoute('/_auth/performance/radar/$employeeId/tree/')({
  validateSearch: searchSchema,
  component: RadarTreePage,
})
